import { ImageDisplayControl } from './ImageDisplayControl.js';

window.customElements.define('image-display-control', ImageDisplayControl, {
  extends: 'img',
});
